import * as React from "react";
import { TextInput, required } from "react-admin";
import Transformer from "../../../common/Transformer";
import { PriceCalculatorEditComponent } from "./";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";
import { PriceCalculatorInput } from "src/components/input";

export const PriceCalculatorEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
    });

    return data;
  };

  return (
    <Edit
      component={PriceCalculatorEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="name" validate={required()}/>
          </Grid>
          <Grid item sm={12}>
            <PriceCalculatorInput source="rules" required base64 fullWidth validate={required()}/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
